import { defaultMessageGroups, Loadable, MessageCategory } from '@eih-netbroker/common';
import { useCallback, useMemo } from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';
import { ReactComponent as MailIcon } from '../../../assets/icons/mail_open.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbFormControlLabel } from '../../../shared/components/form-control-label/FormControlLabel';
import { NbIconButton } from '../../../shared/components/icon-button/IconButton';
import { NbTabs, TabItem } from '../../../shared/components/tabs/Tabs';
import { NbSwitch } from '../../../shared/components/toggle-button/Switch';
import { NbTooltip } from '../../../shared/components/tooltip/Tooltip';
import { useNotification } from '../services/useNotification';
import classes from './MessageCenterHeader.module.scss';

interface MessageCenterHeaderProps {
  onCancel: () => void;
}

const Tabs: MessageCategory[] = [MessageCategory.Event, MessageCategory.Promotion, MessageCategory.Technical];

export const MessageCenterHeader = ({ onCancel }: MessageCenterHeaderProps) => {
  const { readAllMessages, setActiveCategory, setShowOnlyUnread, activeCategory, messages, showOnlyUnread } =
    useNotification();
  const { translation } = useLocale();

  const handleOnReadAllMessages = useCallback(() => {
    readAllMessages();
    // setActionsPopover(null);
  }, [readAllMessages]);

  const tabItems = useMemo(() => {
    const groups = Loadable.getOrElse(messages, { groups: defaultMessageGroups }).groups;
    return Tabs.map((category): TabItem => {
      const messagesInCategory = groups[category].filter(m => !m.isRead);
      const categoryLabel = translation.messageCenter.categories[category];
      return {
        id: category,
        label: `${categoryLabel} (${messagesInCategory.length})`,
      };
    });
  }, [messages, translation]);

  return (
    <div className={classes.header}>
      <div className={classes.headerTabs}>
        <NbTabs
          tabs={tabItems}
          selected={tabItems.findIndex(group => group.id === activeCategory)}
          onTabChange={(_, tabItem) => setActiveCategory(tabItem.id as MessageCategory)}
        />
      </div>
      <div className={classes.headerActions}>
        <NbFormControlLabel
          control={
            <NbSwitch
              color="secondary"
              size="small"
              value={showOnlyUnread}
              onChange={(_, checked) => setShowOnlyUnread(checked)}
            />
          }
          label={translation.messageCenter.onlyUnreads}
        />

        {/*// NN-2897 - do not rely on this, removed context only for 1.0, because there was only one button there -
        discussed with Szabi */}
        <NbTooltip
          title={translation.messageCenter.markAllAsRead}
          placement={'top'}
        >
          <span>
            <NbIconButton
              icon={<MailIcon />}
              onClick={handleOnReadAllMessages}
              className={classes.headerMarkAllRead}
            />
          </span>
        </NbTooltip>

        <NbIconButton
          size={'small'}
          icon={<CloseIcon />}
          onClick={onCancel}
        />
      </div>
    </div>
  );
};
